// Angular
import {ComponentFactoryResolver} from '@angular/core';
import {Router} from '@angular/router';
// Store
import {Store} from '@ngxs/store';
import {SetSelectedRule} from '../state/action/rules.actions';
// Service
import {LoggerService, ObjectUtils, SubContentService, UserContextState} from '@cv-invision/core';
// Component
import {RulesComponent} from '../rules.component';
// Model
import {DOCUMENT_RULES_UI_SECTIONS} from '../../model/quality.constant';
import {RulesState} from '../state/rules.state';
import {SetSelectedSection} from '../../state/actions/quality.actions';

/**
 * Abstract class that can be extended for every component that wants to use the Rule Engine
 * On the Intelligence Product. It contains most of the methods to open and ensure the rules are open
 * from the sub component
 */
export abstract class RuleEngine {

	public static currentUISection: DOCUMENT_RULES_UI_SECTIONS;

	protected constructor(
		public componentFactoryResolver: ComponentFactoryResolver,
		public router: Router,
		public store: Store,
		public loggerService: LoggerService,
		public subContentService: SubContentService
	) {}

	/**
	 * Checks if current ui section matches the selected rule.
	 * @param selectedRule
	 * @param UISection
	 */
	public static isCurrentUISection(selectedRule: any, UISection: string): boolean {
		return (
			selectedRule.uiSection !== undefined && (selectedRule.uiSection.toUpperCase() === UISection.toUpperCase() ||
				ObjectUtils.removeStringWhitespace(selectedRule.uiSection.toUpperCase()) === UISection.toUpperCase())
		);
	}

	/**
	 * Set the Section on the Storage based on the UI Section Name
	 * @param uiSection
	 */
	public static setSelectedSection(store: Store, uiSection: DOCUMENT_RULES_UI_SECTIONS): void {
		// Set the Current Section
		RuleEngine.currentUISection = uiSection;

		const navItems = store.selectSnapshot(UserContextState.getNavItems);
		const navItem = navItems.find((nav: any) => {
			return (
				nav.path &&
				(nav.path.toUpperCase() === uiSection.toUpperCase() ||
					nav.path.toUpperCase() ===
					ObjectUtils.removeStringWhitespace(uiSection.toUpperCase()))
			);
		});
		if (navItem) {
			store.dispatch(new SetSelectedSection(navItem));
		}
	}

	/**
	 * Get all Rules of an Order
	 */
	public getRules(): void {
		if (!this.subContentService.isSubContentPanelOpen) {
			this.subContentService
				.open({
					componentFactoryResolver: this.componentFactoryResolver,
					component: RulesComponent,
					data: {}
				})
				.subscribe((ruleEvent: any) => {
					this.store.dispatch(new SetSelectedRule(ruleEvent));
					const onRevised = this.store.selectSnapshot(RulesState.getSelectedOnRevised);
					// If the UI Section of Rule Selected does not match the current section, redirect to it
					if (
						ruleEvent.uiSection &&
						ruleEvent.uiSection !== RuleEngine.currentUISection &&
						!onRevised
					) {
						const navItems = this.store.selectSnapshot(UserContextState.getNavItems);
						const navItem = navItems.find((nav: any) => {
							return (
								nav.path &&
								(nav.path.toUpperCase() === ruleEvent.uiSection.toUpperCase() ||
									nav.path.toUpperCase() ===
										ObjectUtils.removeStringWhitespace(ruleEvent.uiSection.toUpperCase()))
							);
						});
						if (navItem) {
							this.router.navigate([navItem.route]);
						} else {
							this.loggerService.error(
								//eslint-disable-next-line
								`ui section didn\'t get any match ${ruleEvent.uiSection} at the nav`
							);
						}
					}
				});
		}
	}
}
